import {Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';

import SettlementAccountsFilters from './SettlementAccountsFilters';
import SettlementAccountsTable from './SettlementAccountsTable';
import useSettlementAccountList from './useSettlementAccountList';

/**
 * Afriex's own bank accounts: the ones fee invoices are paid into. Its own entry
 * under Merchants, next to Invoices, now that it is no longer a tab on the Fees
 * screen. Saved once here, then picked per invoice by the payment currency.
 */
const MerchantSettlementAccountList = () => {
  const {
    isLoading,
    list,
    pageInfo,
    fetchList,
    refetchCurrentPage,
    displayPage,
    isPageReset,
    filterCount,
    filtersToApply,
    clearFilters,
    selectAppliedFilters,
    handleApplyFilters,
  } = useSettlementAccountList();

  const renderList = () => {
    if (isLoading) {
      return <TableSkeleton />;
    }

    if (!list.length) {
      return (
        <p className="py-10 text-center text-gray-500 dark:text-gray-400">
          No settlement accounts found.
        </p>
      );
    }

    return (
      <SettlementAccountsTable items={list} onSaved={refetchCurrentPage} />
    );
  };

  return (
    <main className="">
      <SettlementAccountsFilters
        filterCount={filterCount}
        filtersToApply={filtersToApply}
        clearFilters={clearFilters}
        selectAppliedFilters={selectAppliedFilters}
        handleApplyFilters={handleApplyFilters}
        onAccountSaved={refetchCurrentPage}
      />

      <section className="pt-5 md:pt-5">{renderList()}</section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isPageReset={isPageReset}
          currentPageOverride={displayPage}
        />
      ) : null}
    </main>
  );
};

export default MerchantSettlementAccountList;
